import React, { ErrorInfo } from 'react';
import { GeneralErrorScreen } from './GeneralErrorScreen';
import { sendErrorToBackend } from 'common/utils/requestUtils';

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

const initialState = { hasError: false };

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = initialState;
    this.reset = this.reset.bind(this);
  }

  reset() {
    this.setState(initialState);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, _errorInfo: ErrorInfo) {
    sendErrorToBackend(error);
  }

  render() {
    if (this.state.hasError) {
      return <GeneralErrorScreen onReset={this.reset} />;
    }

    return this.props.children;
  }
}
